var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        disabled: _vm.disabled,
        filterable: "",
        remote: "",
        "value-key": "id",
        "remote-method": _vm.loadShopList,
        placeholder: "输入店铺名字搜索",
        clearable: ""
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.shop,
        callback: function($$v) {
          _vm.shop = $$v
        },
        expression: "shop"
      }
    },
    _vm._l(_vm.shopList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.name + "(" + item.id + ")", value: item }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e319629", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e319629","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketFormShop.vue
// module id = 906
// module chunks = 75